<template>
    <b-form-group
            v-if="dataIsVisible"
            class="c-select"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <b-form-input
                v-if="readOnly"
                type="text"
                :readonly="true"
                v-model="Core.Select.label(dataValue)"></b-form-input>
        <template v-if="search">
            <v-select v-if="required" v-model="dataValue"
                      :multiple="false"
                      :state="chkState(id)"
                      :options="dataOptions"
                      :placeholder="placeholder">
                <span slot="no-options">{{Core.Definition.getDefinition('Aucune option disponible')}}</span>
            </v-select>
            <v-select v-else v-model="dataValue"
                      :multiple="false"
                      :options="dataOptions"
                      :placeholder="placeholder">
                <span slot="no-options">{{Core.Definition.getDefinition('Aucune option disponible')}}</span>
            </v-select>
        </template>
        <template v-if="!search">
            <b-select v-if="required" v-model="dataValue"
                      :multiple="false"
                      :state="chkState(id)"
                      :placeholder="placeholder">
                <option v-for="option in dataOptions":value="option.value">{{option.label}}</option>
            </b-select>
            <b-select v-else v-model="dataValue"
                      :multiple="false"
                      :placeholder="placeholder">
                <option v-for="option in dataOptions":value="option.value">{{option.label}}</option>
            </b-select>
        </template>

        <div v-if="required && !chkState(id)" style="display: block" class="invalid-feedback">
            <span v-if="invalidFeedbackMessage !== ''">{{invalidFeedbackMessage}}</span>
            <span v-if="invalidFeedbackMessage === ''">{{Core.Definition.getDefinition('Vous devez sélectionner une valeur.')}}</span>
        </div>
    </b-form-group>
</template>

<script>
    import vSelect from 'vue-select'
  export default {
      name: 'InputSelect',
      components: {
          vSelect
      },
      props: {
          options: {
              type: Array,
              default: function() {
                  return []
              }
          },
          required: {
              type: Boolean,
              default: false
          },
          value: {
              type: Object | String,
              default: function() {
                  return null
              }
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          search: {
              type: Boolean,
              default: true
          },
          _isVisible: {
              type: Boolean,
              default: true
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          },
          fieldRefs: {
              type: Array,
              default: function() { return [] }
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
              this.$emit('onSelect', val, this.form.$model, this.fieldRefs)
          },
          options(val) {
              this.dataOptions = val
          }
      },
      mounted() {
          this.dataIsVisible = this._isVisible
          this.dataValue = this.value
          this.dataOptions = this.options
      },
      data: () => {
          return {
              Core: window.Core,
              dataValue: '',
              dataOptions: [],
              dataIsVisible: true
          }
      },
      computed: {
          isVisible: {
              get() {
                  return this.dataIsVisible
              },
              set(val) {
                  this.dataIsVisible = val
              }
          }
      },
      methods: {
          select: function (value) {
              for (let option in this.dataOptions) {
                  option = this.dataOptions[option]
                  if(option.value === value) {
                      this.dataValue = option
                  }
              }
          },
          setOptions(options) {
              this.dataOptions = options
          },
          getOptions() {
              return this.dataOptions
          },
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>